










































































import Vue from "vue";

import { mapState } from "vuex";

import Drawer from "@/components/Nav/Drawer.vue";
import Bottom from "@/components/Nav/Bottom.vue";
import Footer from "@/components/Nav/Footer.vue";

import BlogDrops from "@/views/BlogDrops2.vue";
import Facebook from "@/views/Facebook.vue";
import Spotify from "@/views/Spotify.vue";
import RedesSociais from "@/views/RedesSociais.vue";
import Contato from "@/views/Contato.vue";
import Patrocinador from "@/views/Patrocinador.vue";

export default Vue.extend({
  name: "App",

  components: {
    Drawer,
    Bottom,
    Footer,
    BlogDrops,
    Facebook,
    Spotify,
    RedesSociais,
    Contato,
    Patrocinador
  },

  data: () => ({
    //
    changeTo: 'Modo Desktop',
    drawer: false,
    useragent: "",
    items: [
      { title: "Home", icon: "dashboard" },
      { title: "About", icon: "question_answer" }
    ],
    itemsm: [
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me 2" }
    ]
  }),

  created() {
    var isMobile =
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Mobile/i) ||
      navigator.userAgent.match(/Windows Phone/i)
        ? true
        : false;

    if (isMobile == false && (window.innerWidth <= 800 && window.innerHeight <= 600)) {
      isMobile = true;
    } 

    //isMobile = true;

    this.$store.commit("setIsMobile", isMobile);
    console.log(
      "App-Created navigator.userAgent: ",
      navigator.userAgent,
      isMobile
    );
    this.useragent = navigator.userAgent;

    this.changeTo = this.IsMobile ? "Modo Desktop" : "Modo Mobile";

  },

  watch: {
    IsMobile(val) {
      console.log("App IsMobile: ", this.IsMobile);
    }
  },

  computed: {
    ...mapState(["IsMobile"])
  },

  methods: {
    changeMode: function() {
      this.$store.commit("setIsMobile", !this.IsMobile);

      this.changeTo = this.IsMobile ? "Modo Desktop" : "Modo Mobile";
    },
    showMenu: function(title: string) {
      this.drawer = false;

      if (title === "Blog Drops") {
        this.$store.commit("setIsBlogPost", true);
      } else if (title === "Facebook") {
        this.$store.commit("setIsFacebook", true);
      } else if (title === "Seja nosso patrocinador") {
        this.$store.commit("setIsPatrocinador", true);
      }
    }
  }
});
